<template>
    <v-main v-if="this.$store.getters.getAccessToken" class="mt-n13">
        <div class="mx-1 mt-1 d-flex d-md-none d-lg-none d-xl-none">
            <v-container fluid>
                <EstimationRows></EstimationRows>
            </v-container>
        </div>
        <div class="d-none d-md-flex">
            <v-container xs="12" class="px-3 mb-n7" fluid>

                <v-row>
                    <v-col cols="12">
                        <EstimationRows></EstimationRows>
                    </v-col>
                </v-row>

                <v-container class="mt-15"></v-container>
            </v-container>
        </div>
    </v-main>
</template>

<script>
import EstimationRows from '@/components/order/EstimationRows'

export default {
    name: 'Estimation',
    components: {
        EstimationRows,
    },
    data() {
        return {
            hasReminder: false,
            estimateSearchText: '',
        }
    },
    watch: {
    },
    methods: {
        async checkReminder() {
            if(!this.$store.getters.getAccessToken){
                return
            }
            await this.$store.dispatch('getReminders')
            const reminders = await this.$store.getters.getReminders
            if(reminders.length > 0){
                this.hasReminder = true
            }else{
                this.hasReminder = false
            }
        }
    },
    beforeCreate: function() {

        if(!this.$store.getters.getAccessToken){
            this.$router.push('/user/login')
            return false
        }

    },
    mounted: function() {
        setTimeout(this.checkReminder, 1)
        setInterval(this.checkReminder, this.$store.getters.getCommonRefreshInterval)
    }
}
</script>